import * as React from "react";
import { Indent, Text } from "@stenajs-webui/core";
import { formatDate } from "@/lib/formatters/DateFormatter";

export const bulkEditRatesStandardTableCell = (
  rowValue: string | number | Array<String> | undefined | null,
  isDateField: boolean = false,
  formatter?: (value: number) => string,
  renderNullValue?: string
) => {
  if (rowValue === undefined || rowValue === null) {
    return (
      <Indent>
        <Text>{renderNullValue ? renderNullValue : ""}</Text>
      </Indent>
    );
  }

  if (isDateField) {
    return (
      <Indent>
        <Text>{formatDate(rowValue as string)}</Text>
      </Indent>
    );
  }

  return (
    <Indent>
      <Text>
        {formatter && typeof rowValue === "number"
          ? formatter(rowValue)
          : rowValue}
      </Text>
    </Indent>
  );
};
